import * as React from "react";
import { connect } from "react-redux";
import get from "lodash/get";

import {
  TierUpgradeRequirement as TierUpgradeRequirementComponent,
  TierUpgradeRequirementProps,
} from "../../components/TierUpgradeRequirement";
import { getMemberTierCustomerAction } from "../../actions";
import { StoreState } from "../../reducers";
import {
  getIsMemberTierLoading,
  getMemberTierCustomer,
} from "../../reducers/methods";

interface TierUpgradeRequirementContainerProps extends TierUpgradeRequirementProps {
  getMemberTierCustomerAction: typeof getMemberTierCustomerAction;
  isLoading: ReturnType<typeof getIsMemberTierLoading>;
  memberTierCustomer: ReturnType<typeof getMemberTierCustomer>;
}

class TierUpgradeRequirement extends React.Component<TierUpgradeRequirementContainerProps> {
  componentDidMount() {
    const isCustomerAuthenticated = get(
      this.props.data,
      "customer.authenticated",
      false
    );

    if (isCustomerAuthenticated && !this.props.isLoading) {
      this.props.getMemberTierCustomerAction();
    }
  }

  render() {
    return <TierUpgradeRequirementComponent {...this.props} />;
  }
}

const mapStateToProp = (state: StoreState) => ({
  isLoading: getIsMemberTierLoading(state),
  memberTierCustomer: getMemberTierCustomer(state),
});

export default connect(mapStateToProp, {
  getMemberTierCustomerAction,
})(TierUpgradeRequirement);
